/** Jedno okno „Nowe zapytanie” (w AppLayout) — inne ekrany otwierają je tym zdarzeniem. */
export const QUICK_CASE_EVENT = 'bqcrm:nowe-zapytanie';
export const openQuickCase = () => window.dispatchEvent(new Event(QUICK_CASE_EVENT));
